import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { wsClient } from '../../services/websocket-client.js';

type ConnectionState = 'connected' | 'disconnected' | 'reconnecting';

const STATUS_CONFIG: Record<ConnectionState, { label: string; modifier: string }> = {
  connected: { label: 'Verbunden', modifier: 'connected' },
  disconnected: { label: 'Keine Verbindung', modifier: 'disconnected' },
  reconnecting: { label: 'Reconnecting', modifier: 'reconnecting' },
};

@customElement('cp-connection-status')
export class CpConnectionStatus extends LitElement {
  createRenderRoot() { return this; }

  @state() private _connectionState: ConnectionState = wsClient.connectionState;

  private _onConnectionState = (e: Event) => {
    this._connectionState = (e as CustomEvent<ConnectionState>).detail;
  };

  connectedCallback() {
    super.connectedCallback();
    wsClient.addEventListener('connection-state', this._onConnectionState);
    this._connectionState = wsClient.connectionState;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    wsClient.removeEventListener('connection-state', this._onConnectionState);
  }

  render() {
    const config = STATUS_CONFIG[this._connectionState];
    return html`
      <div class="cp-connection-status cp-connection-status--${config.modifier}">
        <span class="cp-connection-status__dot"></span>
        <span class="cp-connection-status__label">${config.label}</span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-connection-status': CpConnectionStatus;
  }
}
